<template>
<div id="confirmation">
    <h2>Confirmar pasar a {{to}}?</h2>
</div>
</template>

<script>
export default {
    name: "Confirmation",
    props:{
        to:{
            type:String,
            required:true
        }
    }
}
</script>

<style scoped>

</style>
